import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

const Container = styled(Box)`
	background: ${tokens.warning.background};
	color: ${tokens.warning.text};
	border-radius: ${tokens.radius.sm}px;
`;

export default function LearningEventWarning() {
	const { t } = useTranslation();

	return (
		<Box mt={5}>
			<Container p={3}>{t('learning.event.modal.edit.notificationWarning')}</Container>
		</Box>
	);
}
